import { render, staticRenderFns } from "./StudentScholarshipIssuedList.vue?vue&type=template&id=64ea4402"
import script from "./StudentScholarshipIssuedList.vue?vue&type=script&lang=js"
export * from "./StudentScholarshipIssuedList.vue?vue&type=script&lang=js"
import style0 from "./StudentScholarshipIssuedList.vue?vue&type=style&index=0&id=64ea4402&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports